import {createAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
    traderStrategies,
    editTraderStrategy,
    addTraderStrategy,
    delTraderStrategy,
    assets,
} from '../../services/apiService'

export const traderStrategiesSlice = createSlice({
    name: 'traderStrategies',
    initialState: {
        loading : false,
        traderStrategies: [],
        pagination : {
            showSizeChanger:false,
            total: 0,
            pageSize: 20,
            current: 0
        },
        visibleDialog: false,
        editedTraderStrategy: {},
        assets: []
    },
    reducers: {
        updatePagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        openEditDialog: (state, action) => {
            state.visibleDialog = true;
            state.editedTraderStrategy = action.payload;
        },
        closeEditDialog: (state, action) => {
            state.visibleDialog = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadTraderStrategies.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(loadTraderStrategies.fulfilled, (state, action) => {
                const {content: traderStrategies = [], pageable: page, totalElements} = action.payload;
                const pagination = {
                    total: totalElements,
                    pageSize: page.pageSize,
                    current: page.pageNumber + 1
                };
                state.traderStrategies = traderStrategies;
                state.pagination = pagination;
                state.loading = false;
            })
            .addCase(loadTraderStrategies.rejected, (state, action) => {
                state.traderStrategies = [];
                state.loading = false;
            })
            .addCase(updateTraderStrategy.fulfilled, (state, action) => {
                const updatedTraderStrategy = action.payload;
                const existingIndex = state.traderStrategies.findIndex(
                    strategy => strategy.id === updatedTraderStrategy.id
                );

                if (existingIndex >= 0) {
                    state.traderStrategies[existingIndex] = updatedTraderStrategy;
                } else {
                    state.traderStrategies.unshift(updatedTraderStrategy);
                    if (state.pagination) {
                        state.pagination.total += 1;
                    }
                }
            })
            .addCase(deleteTraderStrategy.fulfilled, (state, action) => {
                const {id} = action.meta.arg;
                state.traderStrategies = state.traderStrategies.filter(strategy => strategy.id !== id);
            })
            .addCase(loadAssets.fulfilled, (state, action) => {
                const assets = action.payload;
                state.assets = assets.filter( asset =>  asset.assetType == 'STOCK_EXCHANGE' );
            })
    }
})

export const { updatePagination, openEditDialog, closeEditDialog } = traderStrategiesSlice.actions;

export const loadTraderStrategies = createAsyncThunk('traderStrategies/loadAdminStrategies', ({pagination, sorting}) => {
    return traderStrategies(pagination, sorting);
})

export const loadAssets = createAsyncThunk('traderStrategies/loadAssets', () => {
    return assets(true);
})

export const updateTraderStrategy = createAsyncThunk('traderStrategies/updateTraderStrategy', (traderStrategy) => {
    const {id, strategy, asset : {id : assetId}, isActive} = traderStrategy;
    const values = {
        strategy,
        assetId,
        isActive
    };

    if(id)
        return editTraderStrategy(id, values);
    else
        return addTraderStrategy(values);
})

export const deleteTraderStrategy = createAsyncThunk('traderStrategies/deleteTraderStrategy', ({id}) => {
    return delTraderStrategy(id);
})

export default traderStrategiesSlice.reducer

